import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-wind-info',
  templateUrl: `../../../../assets/${environment.project}/info_wind.html`,
})
export class WindInfoComponent {}
